import { API_ROUTES, HTTP_METHODS, PAGE_SIZE } from '@Utils/constants';
import { sendCall } from '@Utils/request.utils';
import { KGOffice } from '~/Types/Office.types';

const { USERS } = API_ROUTES;

class AdminService {
  getAdminTypes = () =>
    sendCall(USERS.GET_ADMIN_TYPES, {
      method: HTTP_METHODS.GET,
    }).then((result) =>
      result.data.map((fetchedRole: { id: string; Description: string }) => ({
        id: fetchedRole.id,
        description: fetchedRole.Description,
      })),
    );

  getAdmins = (page: number, pagination: boolean) =>
    sendCall(`${USERS.GET_ADMIN}?page=${page}&limit=${PAGE_SIZE}&pagination=${pagination}`, {
      method: HTTP_METHODS.GET,
    });

  createAdmin = async (name: string, email: string, role: string, locations: KGOffice[], photoUrl: string) => {
    const body = {
      Name: name,
      Email: email,
      UserType: role,
      OverseenLocations: locations,
      PhotoURL: photoUrl,
    };

    const { data } = await sendCall(USERS.CREATE_ADMIN, {
      method: HTTP_METHODS.POST,
      data: body,
    });
    return {
      id: data.result.id,
      Name: data.result.Name,
      Email: data.result.Email,
      Role: data.result.UserType,
    };
  };

  editAdmin = async (id: string | undefined, role: string, locations: KGOffice[]) => {
    const body = {
      UserType: role,
      OverseenLocations: locations,
    };

    const { data } = await sendCall(`${USERS.EDIT_ADMIN}/${id}`, {
      method: HTTP_METHODS.POST,
      data: body,
    });
    return {
      id: data.result.id,
      Name: data.result.Name,
      Email: data.result.Email,
    };
  };

  disableAdmin = (id: string | undefined) =>
    sendCall(`${USERS.DISABLE_ADMIN}/${id}`, {
      method: HTTP_METHODS.POST,
    });

  getAdminSearch = (params: unknown, page: number) =>
    sendCall(`${USERS.SEARCH_POST}?page=${page}&limit=${PAGE_SIZE}`, {
      data: params,
      method: HTTP_METHODS.POST,
    });
}

export default new AdminService();
